// npm i tz-lookup
import tzlookup from 'tz-lookup';

export function arrivalInPst(storeArrivalTime, address) {
  if (!storeArrivalTime) return null;
  const t = new Date(storeArrivalTime);
  if (isNaN(t.getTime())) return null;

  const PST = 'America/Los_Angeles';

  const offsetMin = (tz) => {
    const label = new Intl.DateTimeFormat('en', { timeZone: tz, timeZoneName: 'shortOffset', hour: '2-digit' })
      .formatToParts(t).find(p => p.type === 'timeZoneName')?.value || 'UTC+00:00';
    const m = label.replace('UTC','').replace('GMT','').replace(/\s/g,'').replace('−','-').match(/^([+-])(\d{1,2})(?::?(\d{2}))?$/);
    if (!m) return 0;
    const sign = m[1] === '-' ? -1 : 1;
    return sign * ((parseInt(m[2]||'0',10)*60) + parseInt(m[3]||'0',10));
  };

  const pstOff = offsetMin(PST);

  const { lat, lng } = address || {};
  let propTz = null;
  if (isFinite(lat) && isFinite(lng)) {
    try { propTz = tzlookup(lat, lng); } catch {}
  }

  // If no property tz, just show PST in requested format
  if (!propTz) {
    return fmtLong(new Date(t.getTime()), PST);
  }

  const propOff = offsetMin(propTz);
  const deltaMin = propOff - pstOff; // property minus PST at that instant

  // PST wall clock at t
  const pstWallMs = t.getTime() + pstOff * 60000;
  // subtract property tz from PST
  const adjWallMs = pstWallMs - deltaMin * 60000;
  // back to real instant using PST offset at t
  const adjInstant = new Date(adjWallMs - pstOff * 60000);

  return fmtLong(adjInstant, PST);
}

function fmtLong(date, timeZone) {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', {
      timeZone,
      month: 'long', day: 'numeric', year: 'numeric',
      hour: 'numeric', minute: '2-digit',
      hour12: true
    }).formatToParts(date).map(p => [p.type, p.value])
  );
  const dayWithSuffix = addOrdinal(Number(parts.day));
  // parts.hour is already without leading zero when hour12: true and hour: 'numeric'
  return `${parts.month} ${dayWithSuffix}, ${parts.year} ${parts.hour}:${parts.minute} ${parts.dayPeriod}`;
}

function addOrdinal(n) {
  const s = ['th','st','nd','rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
